import {
    ChangeDetectionStrategy,
    Component,
    effect,
    inject,
    input,
    InputSignal,
    signal,
    WritableSignal
} from "@angular/core";
import {LoadingService} from "../loading.service";
import {LoadingStatus} from '../../../session/loading-status';
import {NgClass} from '@angular/common';
import {SpinnerComponent} from '../../spinner/spinner.component';
import {TranslateModule} from '@ngx-translate/core';
import {HtmlPipe} from '../../../utils/html.pipe';
import {SessionModel} from '../../../session/session.model';

@Component({
    selector: "woa-loading-spinner",
    templateUrl: "./loading-spinner.component.html",
    styleUrls: ["./loading-spinner.component.scss"],
    imports: [
        HtmlPipe,
        NgClass,
        SpinnerComponent,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingSpinnerComponent {
    public sessionModel: SessionModel = inject(SessionModel);
    public loadingService: LoadingService = inject(LoadingService);

    LoadingStatus = LoadingStatus;

    private static readonly INDICATOR_DELAY_MS = 500;

    public readonly showMessages: InputSignal<boolean> = input<boolean>(false);

    public indicatorVisible: WritableSignal<boolean> = signal<boolean>(false);

    constructor() {
        effect(() => {
            if (this.loadingService.loading()) {
                setTimeout(() => {
                    if (this.loadingService.loading()) {
                        this.indicatorVisible.set(true);
                    }
                }, LoadingSpinnerComponent.INDICATOR_DELAY_MS);
            } else {
                this.indicatorVisible.set(false);
            }
        });
    }
}
